<template>
  <v-app>
    <router-view @show-alert="showAlert"/>
    <alert-snackbar ref="alert"/>
    <v-snackbar v-model="updateAvailable" :timeout="-1" color="info">
      Hay una nueva versión de iTPV disponible.
      <template #action="{ attrs }">
        <v-btn text v-bind="attrs" @click="reloadForUpdate">Recargar</v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import AlertSnackbar from './components/shared/AlertSnackbar.vue';

export default {
  name: 'App',
  components: {
    AlertSnackbar
  },
  data: () => ({
    updateAvailable: false,
    serviceWorkerRegistration: null,
  }),
  mounted() {
    document.addEventListener('swUpdated', this.onServiceWorkerUpdated);
  },
  beforeDestroy() {
    document.removeEventListener('swUpdated', this.onServiceWorkerUpdated);
  },
  methods: {
    showAlert(options) {
      this.$refs.alert.showAlert(options);
    },
    onServiceWorkerUpdated(event) {
      this.serviceWorkerRegistration = event.detail || null;
      this.updateAvailable = true;
    },
    reloadForUpdate() {
      const waitingWorker = this.serviceWorkerRegistration
        && this.serviceWorkerRegistration.waiting;
      if (waitingWorker) {
        waitingWorker.postMessage({ type: 'SKIP_WAITING' });
      }
      window.location.reload();
    }
  }
};
</script>
